import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTokens } from '../../component-themes';
import { forwardRef } from 'react';
/**
 * Should be used to display a label within `NavigationInfoBarContentCountdownLabel`.
 */
export const NavigationInfoBarContentCountdownItemLabel = forwardRef(({ as: Component = 'div', ...props }, ref) => {
    const tokens = useTokens();
    return (_jsx(Component, { css: {
            color: tokens.styles['navigation-infobar-content-countdown-item-label-color'],
            opacity: tokens.styles['navigation-infobar-content-countdown-item-label-opacity'],
            fontSize: tokens.styles['navigation-infobar-content-countdown-item-label-fontSize'],
            fontFamily: tokens.styles['navigation-infobar-content-countdown-item-label-fontFamily'],
            lineHeight: tokens.styles['navigation-infobar-content-countdown-item-label-lineHeight'],
            fontWeight: tokens.styles['navigation-infobar-content-countdown-item-label-fontWeight'],
            letterSpacing: tokens.styles['navigation-infobar-content-countdown-item-label-letterSpacing'],
        }, ...props, ref: ref }));
});
NavigationInfoBarContentCountdownItemLabel.displayName =
    'NavigationInfoBarContentCountdownItemLabel';
